/**
 * @description: 订单列表
 * @author: 大腿
 * @update: cyp
 * @update: hwx
 */
<template>
	<div class="order-manage-list">
		<div class="order-list" v-show="!showdetail&&!showBillDetail">
			<div class="row row-margin">
				<label class="list-label-2">时间:</label>
				<div class="col-md-3 list-time">
					<div @click="clearDate" ref="time">
						<input type="text" class="form-control laydate-icon" v-model="startTime"> -
						<input type="text" class="form-control laydate-icon" v-model="endTime">
					</div>
				</div>
				<label class="list-label-4">消费门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="list-label-3">包厢号:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" ref="shop_room" placeholder="请选择包厢号" />
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
				<label class="list-label-2">区域:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" data-placeholder="请选择包厢区域" ref="order_room_area"></select>
				</div>
			</div>
			<div class="row row-margin">
				<label class="list-label-4">订单类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" data-placeholder="请选择" ref="ordertype">
						<option value="100">全部</option>
						<option value="1">酒水订单</option>
						<option value="2">开房套餐</option>
						<!-- <option value="3">商品套餐</option> -->
						<option value="4">续时套餐</option>
						<option value="5">计时开房</option>
						<option value="6">预买</option>
						<option value="7">预买续时</option>
						<option value="8">包断</option>
						<option value="9">包断续时</option>
						<option value="10">开房小吃</option>
						<option value="11">扫码购买单</option>
						<option value="12">限时秒杀</option>
					</select>
				</div>
				<label class="list-label-4">支付状态:</label>
				<div class="col-md-2">
					<input class="form-control input-readonly" placeholder="请选择支付状态" v-model="paymentstatus" ref="paymentstatus" readonly @click="paymentstatus_fun($event)">
					<span class="selection-clear" @click="clear_input('paymentstatus_fun')">×</span>
					<span class="span-arrow" role="presentation"><b role="presentation"></b></span>
				</div>
				<label class="list-label-4">支付类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" data-placeholder="请选择" ref="paymenttype"></select>
				</div>
				<label class="list-label-4">订单来源:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" data-placeholder="请选择" ref="order_from">
						<option value="100">全部</option>
						<option value="1">自助下单</option>
						<option value="2">点单收银</option>
						<option value="3">手动开房</option>
						<option value="4">商品赠送</option>
						<option value="5">微信预定</option>
						<option value="6">会员app预定</option>
					</select>
				</div>
			</div>
			<div class="row row-margin">
				<label class="list-label-4">订单编号:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="请输入订单号" ref="ordername">
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
				<label class="list-label-4">导购员工:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" ref="order_staff" placeholder="请选择导购员工" readonly />
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
				<label class="list-label-3">操作人:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" data-placeholder="请选择操作人" ref="order_admin"></select>
				</div>
			</div>
			<div class="row">
				<label class="list-label-4">消费金额:</label>
				<div class="list-total">{{ total_amount | formateMoney }} 元</div>
				<label class="list-label-4">实收金额:</label>
				<div class="list-total">{{ total_actual_pay | formateMoney }} 元</div>
				<label class="list-label-4">退款总额:</label>
				<div class="list-total">{{ total_refund_amount | formateMoney }} 元</div>
				<span class="rmarkspan" titles="消费金额取：优惠价/会员价<br />实收金额取：消费者最后支付价<br />实收金额不含退款总额" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>

				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList">查询</button>
					<button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getExportSet">导出</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="orderlist"></table>
			</div>
			<!-- 导出设置弹窗 -->
			<div class="ele-hide" ref="export_alert">
				<div class="set-export sel-seldiv">
					<h3>请选择导出报表需要的显示的字段</h3>
					<ul class="set-area clearfix">
						<li>
							<input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
							<label>全选</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="shop_name">
							<label>消费门店</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="room_name">
							<label>包厢号</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="room_area">
							<label>区域</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="id">
							<label>订单编号</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="amount">
							<label>消费金额</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="actual_pay">
							<label>实收金额</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="refund_amount">
							<label>退款金额</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="timestamp">
							<label>下单时间</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="type">
							<label>订单类型</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="pay_platform">
							<label>支付类型</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="status">
							<label>支付状态</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="pay_scene">
							<label>订单来源</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="shopping_guide">
							<label>导购员工</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="admin_name">
							<label>操作人</label>
						</li>
					</ul>
					<h3>请选择导出报表的文件格式</h3>
					<ul class="clearfix">
						<li>
							<input type="radio" v-model='export_type' value="1">
							<label>excel表格</label>
						</li>
						<li>
							<input type="radio" v-model='export_type' value="2">
							<label>pdf文件</label>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 支付状态弹窗 -->
		<div class="ele-hide" ref="paymentstatus_alert">
			<div class="sel-seldiv">
				<ul class="set-area">
					<li>
						<input type='checkbox' v-model='status_allcheck' v-on:click='statusCheckedAll'>
						<label>全选</label>
					</li>
					<li>
						<input type="checkbox" v-model='status_checkboxModel' value="-1">
						<label>待支付</label>
					</li>
					<li>
						<input type="checkbox" v-model='status_checkboxModel' value="1">
						<label>已付款</label>
					</li>
					<li>
						<input type="checkbox" v-model='status_checkboxModel' value="2">
						<label>异常</label>
					</li>
					<li>
						<input type="checkbox" v-model='status_checkboxModel' value="4">
						<label>退款完成</label>
					</li>
				</ul>
			</div>
		</div>
		<!-- 订单详情 -->
		<div class="order-detail" v-show="showdetail">
			<orderDetail ref="order_det" @backOdwPre="showdetail = false"></orderDetail>
		</div>
		<!-- 账单详情 -->
        <div class="bill-detail" v-show="showBillDetail">
            <billDetail ref="bill_det" @backBdwPre="showBillDetail=false"></billDetail>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import orderDetail from '@/components/order_detail.vue';
	import billDetail from '@/components/bill_detail.vue';
	export default {
		name: 'order_manage',
		data() {
			return {
				showdetail: false,
				startTime: "",
				endTime: "",
				shop_room_name: {
					value: []
				},
				paymentstatus: "",
				status_allcheck: false,
				c_status_allcheck: false,
				status_checkboxModel: [],
				status_checkboxData: [{id: "-1", name: "待支付"}, {id: "1", name: "已付款"}, {id: "2", name: "异常"}, {id: "4", name: "退款完成"}],
				paytype: [],
				orderStaffDatas: [],
				total_amount: "",
				total_actual_pay: "",
				total_refund_amount: "",
				export_allcheck: false,
				c_export_allcheck: false,
				export_checkModel: [],
				export_checkData: ['shop_name', 'room_name', 'room_area', 'id', 'amount', 'actual_pay', 'refund_amount', 'timestamp', 'type', 'pay_platform', 'status', 'pay_scene', 'shopping_guide', 'admin_name'],
				export_type: 1,
				showBillDetail: false,
			}
		},
		components: {
			"orderDetail": orderDetail,
			"billDetail": billDetail
		},
		filters: {
			formateMoney: function(value) {
				if(value < 0) {
					return "0.00";
				} else {
					return(value - 0).toFixed(2);
				}
			}
		},
		watch: {
			paymentstatus: {
				handler: function(val, oldval) {
					if(val != ""){
						$(this.$refs.paymentstatus).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.paymentstatus).parent().find('.selection-clear').hide();
					}
				},
				deep:true
			},
			status_checkboxModel: {
				handler: function(val, oldVal) {
					if(this.status_checkboxModel.length >= this.status_checkboxData.length) {
						// if(this.initaddopertwo==true){
						//     this.initaddopertwo=false;
						//     return;
						// }
						this.status_allcheck = true;
						this.c_status_allcheck = true;
					} else {
						this.status_allcheck = false;
						this.c_status_allcheck = false;
					}
				},
				deep: true
			},
			export_checkModel: {
				handler: function(val, oldVal) {
					if(this.export_checkModel.length >= this.export_checkData.length) {
						this.export_allcheck = true;
						this.c_export_allcheck = true;
					} else {
						this.export_allcheck = false;
						this.c_export_allcheck = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.$nextTick(function() {
				let _this = this;
				// 日期
				var myDate = new Date();
				this.IntstartTime = myDate;
				this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
				this.IntstartTime.setHours(8, 0);
				this.IntendTime.setHours(8, 0);
				var timStar = new Date(this.IntstartTime),
					year = timStar.getFullYear(),
					month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
					day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
					hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
					minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
				var timEnd = new Date(this.IntendTime),
					yearend = timEnd.getFullYear(),
					monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
					dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
					hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
					minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
				this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
				this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
				this.innitDate();
				this.innitInput();
				$(_this.$refs.ordertype).select2({
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				$(_this.$refs.order_from).select2({
					allowClear: true,
					minimumResultsForSearch: -1
				});

			});
		},
		methods: {
			// 修改页的提示语
			hint_language: function(e) {
				var contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
				layer.tips(contents, $(e.currentTarget), {
					skin: 'hint_language_tip',
					tips: [2, '#fff'],
					time: 2000000,
				});
			},
			// 关闭提示语
			close_hint_language: function() {
				layer.closeAll('tips');
			},
			// 初始化日期插件
			innitDate: function() {
				let _this = this;
				$(_this.$refs.time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime,
					dateLimit: {
						days: 31
					},
				}, function(start, end, label) {
					_this.startTime = start.format('YYYY-MM-DD HH:mm');
					_this.endTime = end.format('YYYY-MM-DD HH:mm');
				});
			},
			// 清空日期
			clearDate: function() {
				this.startTime = "";
				this.endTime = "";
			},
			// 初始化门店
			innitInput: function() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": "1",
							"page_size": "0",
							"name": "",
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN"
							}).on("select2:select", function(e) {
								if(e.params.data.text == "全部") {
									$(_this.$refs.shop_room).attr("disabled", true);
									$(_this.$refs.shop_room).val('').trigger('change');
									$(_this.$refs.shop_room).attr("data-id", '');
									$(_this.$refs.order_staff).attr("disabled", true);
									$(_this.$refs.order_staff).val('').trigger('change');
									$(_this.$refs.order_staff).attr("data-id", '');
									// 包厢区域
                                    $(_this.$refs.order_room_area).val('').trigger('change');
                                    $(_this.$refs.order_room_area).prop("disabled", true);
									// 获取支付类型
									_this.getPaytype(e.params.data.id);
									return;
								}
								$(_this.$refs.shop_room).val('').trigger('change');
								$(_this.$refs.shop_room).attr("data-id", '');
								_this.innitShopRoom(e.params.data.id);

								$(_this.$refs.order_staff).val('').trigger('change');
								$(_this.$refs.order_staff).attr("data-id", '');
                                // 包厢区域
                                $(_this.$refs.order_room_area).prop("disabled", false);
                                _this.getRoomArea(e.params.data.id);
								// 获取支付类型
								_this.getPaytype(e.params.data.id);
								_this.getOrderStaff(e.params.data.id);
								_this.getAdmin(e.params.data.id);
							});
							$(_this.$refs.shop).val(data.response.result[1].id).trigger('change');

							// 包厢区域
							$(_this.$refs.order_room_area).prop("disabled", false);
							_this.getRoomArea(data.response.result[1].id);
							// 获取支付类型
							_this.getPaytype(data.response.result[1].id);

							_this.innitShopRoom(data.response.result[1].id);
							_this.getOrderStaff(data.response.result[1].id);
							_this.getAdmin(data.response.result[1].id);
							_this.innitTable();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化门店包厢
			innitShopRoom: function(shop_id) {
				let _this = this;
				let innitSuggest = function() {
					$(_this.$refs.shop_room).bsSuggest("destroy");
					$(_this.$refs.shop_room).bsSuggest({
						data: _this.shop_room_name,
						ignorecase: true,
						showHeader: false,
						showBtn: false, //不显示下拉按钮
						delayUntilKeyup: true, //获取数据的方式为 firstByUrl 时，延迟到有输入/获取到焦点时才请求数据
						idField: "id",
						keyField: "name",
						effectiveFields: ["name"],
						inputWarnColor: "white", //输入框内容不是下拉列表选择时的警告色
					}).on('onSetSelectValue', function(e, keyword, data) {
						
					});
				};
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id || "",
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getAllRoom",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.shop_room_name.value = [];
							$.each(data.response.result, function(k, v) {
								_this.shop_room_name.value.push({
									id: v.id,
									name: v.name
								});
							});
							if(_this.shop_room_name.value.length < 1) {
								$(_this.$refs.shop_room).attr("disabled", true);
							} else {
								$(_this.$refs.shop_room).removeAttr("disabled");
								innitSuggest();
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.order_room_area).html('');
                            $(_this.$refs.order_room_area).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
			// 获取支付类型
			getPaytype: function(shop_id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Order/getAllPayPlatform",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.paytype = [{id: '100', text: '全部'}];
							let value = data.response.data;
							for(var key in value) {
								_this.paytype.push({id: key, text: value[key]});
							}
							$(_this.$refs.paymenttype).html('');
							$(_this.$refs.paymenttype).select2({
								data: _this.paytype,
								allowClear: true,
								minimumResultsForSearch: -1
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 选择支付状态
			paymentstatus_fun: function(e) {
				let _this = this;
				let c_status_checkboxModel = _this.status_checkboxModel;
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['支付状态', true],
					area: ['300px', ''], // 宽高
					content: $(_this.$refs.paymentstatus_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.paymentstatus != "") {
							_this.status_checkboxModel = c_status_checkboxModel;
							return;
						}
						_this.status_checkboxModel = [];
					}
				}, function() {
					var texts = [];
					_this.status_checkboxData.forEach(function(item) {
						_this.status_checkboxModel.forEach(function(item2) {
							if(item.id == item2){
								texts.push(item.name);
							}
						});
					});
					_this.paymentstatus = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.paymentstatus != "") {
						_this.status_checkboxModel = c_status_checkboxModel;
						return;
					}
					_this.status_checkboxModel = [];
				});
			},
			// 全选
			statusCheckedAll:function() {
				var _this = this;
				_this.status_allcheck = _this.c_status_allcheck;
				if(!_this.status_allcheck) { // 实现全选
					_this.status_checkboxModel = [];
					_this.status_checkboxData.forEach(function(item) {
						_this.status_checkboxModel.push(item.id);
					});
				} else { // 实现反选
					_this.status_checkboxModel = [];
				}
			},
			// 清空
			clear_input: function(name) {
				this.paymentstatus = "";
				this.status_checkboxModel = [];
			},
			// 导购员工数据
			getOrderStaff: function(shop_id) {
				let _this = this;
				let innitSuggest = function() {
					$(_this.$refs.order_staff).bsSuggest("destroy");
					$(_this.$refs.order_staff).bsSuggest({
						data: _this.orderStaffDatas,
						ignorecase: true,
						showHeader: false,
						showBtn: false, // 不显示下拉按钮
						delayUntilKeyup: true, // 获取数据的方式为 firstByUrl 时，延迟到有输入/获取到焦点时才请求数据
						idField: "id",
						keyField: "name",
						effectiveFields: ["name"],
						inputWarnColor: "white", // 输入框内容不是下拉列表选择时的警告色
					});
				};
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id || "",
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "user/getSearchList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.orderStaffDatas.value = [];
							$.each(data.response.result, function(k, v) {
								_this.orderStaffDatas.value.push({
									id: v.id,
									name: v.name
								});
							});
							if(_this.orderStaffDatas.value.length < 1) {
								$(_this.$refs.order_staff).attr("readonly", "readonly");
							} else {
								$(_this.$refs.order_staff).removeAttr("readonly");
								innitSuggest();
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取操作人数据
			getAdmin: function(shop_id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "User/getList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [{ id: " ", text: "全部" }];
							$.each(data['response']['result']['user_info'], function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.order_admin).html("");
							$(_this.$refs.order_admin).select2({
								data: arr,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化订单列表表格
			innitTable: function() {
				let _this = this;
				$(_this.$refs.orderlist).bootstrapTable("destroy");
				$(_this.$refs.orderlist).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getOrderList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "no",
						title: "订单<br />序号",
						width: "5%",
						valign: "middle"
					}, {
						field: "shop_name",
						title: "消费门店",
						width: "10%",
						valign: "middle"
					}, {
						field: "room_name",
						title: "包厢号",
						width: "5%",
						valign: "middle"
					}, {
						field: "room_area",
						title: "区域",
						width: "5%",
						valign: "middle"
					}, {
						field: "id",
						title: "订单编号",
						width: "11%",
						valign: "middle"
					}, {
						field: "amount",
						title: "消费<br />金额",
						width: "5%",
						valign: "middle"
					}, {
						field: "actual_pay",
						title: "实收<br />金额",
						width: "5%",
						valign: "middle"
					}, {
						field: "refund_amount",
						title: "退款<br />金额",
						width: "5%",
						valign: "middle"
					}, {
						field: "timestamp",
						title: "下单时间",
						width: "10%",
						valign: "middle"
					}, {
						field: "type_show",
						title: "订单<br />类型",
						width: "5%",
						valign: "middle"
					}, {
						field: "pay_platform_show",
						title: "支付<br />类型",
						width: "5%",
						valign: "middle"
					}, {
						field: "status_show",
						title: "支付<br />状态",
						width: "5%",
						valign: "middle"
					}, {
						field: "pay_scene_type",
						title: "订单<br />来源",
						width: "5%",
						valign: "middle"
					}, {
						field: "shopping_guide",
						title: "导购<br />员工",
						width: "5%",
						valign: "middle"
					}, {
						field: "admin_name",
						title: "操作人",
						width: "5%",
						valign: "middle"
					}, {
						title: "操作",
						width: "15%",
						valign: "middle",
						events: {
							'click .detail': function(e, value, row) {
								_this.$refs.order_det.getOdwDetail(row.id);
								_this.showdetail = true;
							},
							'click .reopen': function(e, value, row, index) {
								layer.confirm("确定重新开房吗？", {
									btn: ['确定', '取消'], //按钮
								}, function() {
									_this.$refs.order_det.odwReopenRoom(row.id);
								});
							},
							'click .bill-detail': function(e, value, row, index) {
								_this.checkBillDetail(row.bill_no)
							},
						},
						formatter: function(value, row, index) {
							if(row.type == '2' && row.notice_status == '2') {
								return '<span class="text-blue reopen">重新开房</span><br /><span class="text-blue detail">详情</span><span class="text-blue bill-detail">关联账单</span>'
							} else {
								return '<span class="text-blue detail">详情</span><span class="text-blue bill-detail">关联账单</span>'
							}
						}
					}],
				});
			},
			// 获取订单列表
			getOrderList: function(params) {
				let _this = this,
					shop_id = $(_this.$refs.shop).val(),
					room_id = $(_this.$refs.shop_room).attr("data-id"),
					order_id = $(_this.$refs.ordername).val(),
					ordertype = $(_this.$refs.ordertype).val(),
					pay_id = [],
					pay_platform = $(_this.$refs.paymenttype).val(),
					pay_scene = $(_this.$refs.order_from).val(),
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				if(_this.status_checkboxModel.length != '0' && _this.status_checkboxModel.length != '4') {
					for( var i in _this.status_checkboxModel ){
						pay_id.push(_this.status_checkboxModel[i]);
					}
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"room_id": room_id,
							"room_area": $.trim($(_this.$refs.order_room_area).val()),
							"pay_id": pay_id,
							"type": ordertype == '100' ? "" : ordertype || "",
							"start_date": _this.startTime,
							"end_date": _this.endTime,
							"pay_platform": pay_platform == '100' ? "" : pay_platform || "",
							"pay_scene": pay_scene == '100' ? "" : pay_scene,
							"order_id": order_id,
							"shopping_guide": $(_this.$refs.order_staff).attr("data-id") || '',
							"admin_id": $.trim($(_this.$refs.order_admin).val())
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Order/getList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.count,
								rows: data.response.result.order_info
							});
							_this.total_amount = data.response.result.total_amount;
							_this.total_actual_pay = data.response.result.total_actual_pay;
							_this.total_refund_amount = data.response.result.total_refund_amount;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 查看账单
            checkBillDetail(bill_no) {
                this.$refs.bill_det.getBdwDetail(bill_no)
                this.showBillDetail = true
            },

			// 获取导出设置
			getExportSet: function() {
				let _this = this;
				if($(_this.$refs.shop).val() == '0') {
					layer.msg('请选择一个门店');
					return;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "Order/export"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FinanceReport/getExportSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result) {
								_this.export_checkModel = data.response.result.export_fields;
								_this.export_type = data.response.result.export_type;
							} else {
								_this.export_checkModel = _this.export_checkData;
								_this.export_type = 1;
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.export_alert)
				}, function() {
					_this.exportList();
				});
			},
			// 导出字段全选
			exportCheckedAll: function() {
				let _this = this;
				_this.export_allcheck = _this.c_export_allcheck;
				if(!_this.export_allcheck) { // 实现全选
					_this.export_checkModel = [];
					_this.export_checkData.forEach(function(item) {
						_this.export_checkModel.push(item);
					});
				} else { // 实现反选
					_this.export_checkModel = [];
				}
			},
			// 点击“导出”按钮
			exportList: function() {
				let _this = this,
					shop_id = $(_this.$refs.shop).val(),
					room_id = $(_this.$refs.shop_room).attr("data-id") || "",
					pay_id = [],
					ordertype = $(_this.$refs.ordertype).val() == 100 ? "" : $(_this.$refs.ordertype).val(),
					pay_platform = $(_this.$refs.paymenttype).val() == 100 ? "" : $(_this.$refs.paymenttype).val(),
					pay_scene = $(_this.$refs.order_from).val() == 100 ? "" : $(_this.$refs.order_from).val(),
					order_id = $(_this.$refs.ordername).val(),
					shopping_guide = $(_this.$refs.order_staff).attr("data-id") || '';
				let export_fields = JSON.stringify(_this.export_checkModel);
				if(_this.status_checkboxModel.length != '0' && _this.status_checkboxModel.length != '4') {
					for( var i in _this.status_checkboxModel ){
						pay_id.push(_this.status_checkboxModel[i]);
					}
				}
				window.location.href = Vue.ctUrl +
					"Order/export?" +
					"shop_id=" + shop_id +
					"&room_id=" + room_id +
					"&room_area=" + $.trim($(_this.$refs.order_room_area).val()) +
					"&pay_id=" + pay_id +
					"&type=" + ordertype +
					"&start_date=" + _this.startTime +
					"&end_date=" + _this.endTime +
					"&pay_platform=" + pay_platform +
					"&pay_scene=" + pay_scene +
					"&order_id=" + order_id +
					"&shopping_guide=" + shopping_guide +
					"&admin_id=" + $.trim($(_this.$refs.order_admin).val()) +
					"&export_fields=" + export_fields +
					"&export_type=" + _this.export_type;
				
				layer.msg("导出成功！");
				layer.closeAll();
			},
			// 点击“查询”按钮
			queryList: function() {
				this.innitTable();
			}
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.order-manage-list {
		.order-list {
			.pull-right {
				button {
					margin: 0 0 0 30px;
				}
			}
			.set-export {
				padding: 0 20px 20px;
				h3 {
					font-size: 16px;
				}
				li {
					float: left;
					width: 20%;
				}
			}
		}
	}
</style>